import React from "react";
import Layout from '../components/layout'
import { graphql } from "gatsby"
import Helmet from 'react-helmet'
import Footer from '../components/Footer'

class BrandingTemplate extends React.Component{
  render(){
    const branding = this.props.data.branding;
    const sortedGalleryPaths = branding.imageGalleryPaths.sort();
    let initialImage = sortedGalleryPaths[0];
    let basePath = "//images.clairestelle.com/ImageGalleries/branding";
    let initialImagePath = `${basePath}/${branding.imageGallery}/${initialImage}`;
    
    return (
      <Layout pageType="brandingGallery" location={this.props.location}>
        <Helmet title={`${branding.title} | Branding | ${branding.location} | Clair Estelle`} />
        <main>
          <div className="branding-wrapper">
            <div className="branding-content">
              <img src={initialImagePath} alt="" />
              <div className="mobile-only">
                <h2><span>{branding.title} /</span><br />/ branding / {branding.location}</h2>
                <div className="content-container" dangerouslySetInnerHTML={{ __html: branding.content }} />
              </div>
              <div className="gallery-images">
              {
                sortedGalleryPaths.slice(1).map( imageGalleryPath => {
                  
                  let path = `${basePath}/${branding.imageGallery}/${imageGalleryPath}`;
                  return  <img src={path} alt="" />;
                  
                })
              }
              </div>
            </div>
          </div>
          <Footer  />
        </main>
        <div className="sidebar-right">
            <h2><span>{branding.title} /</span><br /> branding / {branding.location}</h2>
            <div dangerouslySetInnerHTML={{ __html: branding.content }} />
        </div> 
      </Layout>
    );
  }
}

export default BrandingTemplate

export const query = graphql`
  query($slug: String!) {
    branding(slug: { eq: $slug }) {
      title,
      location,
      previewImagePath,
      content,
      imageGallery,
      imageGalleryPaths
    }
  }
`;